import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { User } from '@shared/models/user.model';

@Component({
  selector: './confirm-edition-modal.component',
  templateUrl: './confirm-edition-modal.component.html',
  styleUrls: ['./confirm-edition-modal.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],

})
export class ConfirmEditionModalComponent {
  warnMessage: string;
  takeOverButtonLabel = 'TAKE OVER';

  constructor(
    private dialogRef: MatDialogRef<ConfirmEditionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: { label: string, user?: User, isMe?: boolean, forcedEntrance?: boolean }
  ) {
    // Prevent closing the dialog by click out
    dialogRef.disableClose = true;
    if (this._data.isMe) {
      this.warnMessage = `You are already editing this ${this._data.label} in another browser/tab.`;
      this.takeOverButtonLabel = 'EDIT HERE';
    } else {
      const name = this._data.user ? this._data.user.first_name : 'Someone';
      this.warnMessage = this._data.forcedEntrance ? `${name} took over editing of the ${this._data.label}`
        : `${name} is currently editing this ${this._data.label}. Do you want to take over?`;
    }
  }
  onClose(param: boolean): void {
    return this.dialogRef.close(param);
  }
}
